//获取webapp资源
import { httpGet } from "src/utils/httpRequest";
import { getConfig } from "src/services/server-url-config/env";
import { getLocale } from "src/gs-utils/core/storage/LocaleManager";

const config = getConfig();
const apiGatewayPrefix = config.apiUrl.apiGatewayPrefix

export const getWebappRobotStatus = async () => {
  return httpGet(`${apiGatewayPrefix}/static/webapp/robot_status_function/v1/robot_status.json?t=${+new Date}`)
};

export const getWebappDeviceLimits = async () => {
  return httpGet(`${apiGatewayPrefix}/static/webapp/device_limits/${getLocale()}.json?t=${+new Date}`)
};
